module.exports = __webpack_public_path__ + "static/media/texture (23).4c7a6de5.jpg";